import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MarkdownViewer from "../atoms/MarkdownViewer";

/**
 * MarkdownViewerPage - Page for viewing Markdown files
 */
const MarkdownViewerPage = () => {
  const { url } = useParams();
  const navigate = useNavigate();
  const [decodedUrl, setDecodedUrl] = useState("");

  useEffect(() => {
    if (url) {
      try {
        // Decode the URL parameter
        const decoded = decodeURIComponent(url);
        setDecodedUrl(decoded);
      } catch (error) {
        console.error("Error decoding URL:", error);
      }
    }
  }, [url]);

  return (
    <div className="min-h-screen bg-[#121417] p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-white text-xl font-medium">Markdown Viewer</h1>
          <button
            onClick={() => navigate(-1)}
            className="bg-[#1a1e21] text-white px-4 py-2 rounded hover:bg-[#262b30] transition-colors"
          >
            Back
          </button>
        </div>

        {decodedUrl ? (
          <MarkdownViewer url={decodedUrl} />
        ) : (
          <div className="bg-[#1a1e21] text-white p-6 rounded-lg">
            <p>No URL provided. Please specify a Markdown file to view.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarkdownViewerPage;
